export default class LayoutSize {
  id: number = 0;
  compatible_layouts: number[] = [];
  image: string = "";
  name: string = "";
  icon: string = "";
  price: string | null = null;
  dimensions: string | null = null;
  range_price_percentage: string = "";
  code: string = "";
  is_draft: boolean = false;

  constructor(data: Partial<LayoutSize>) {
    Object.assign(this, data);
  }
}
